var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingsNewConstruction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1970.000000, -370.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Buildings/New-construction",
    transform: "translate(1970.000000, 370.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.829,13.9444375 L17.856,24.25 L11,17.4329062 L21.698,11.82675 C23.002,11.1437812 24.516,12.6501875 23.829,13.9444375 L23.829,13.9444375 Z M13.261,23.28125 L12,22.0586875 L12.739,21.34375 L14,22.5663125 L13.261,23.28125 Z M11.716,25.5452187 L9.336,27.849875 C8.958,28.2170312 8.347,28.2170312 7.968,27.849875 L7.284,27.18725 C6.905,26.8210625 6.905,26.2272187 7.284,25.862 L9.663,23.5554062 C10.042,23.1892188 10.653,23.1892188 11.032,23.5554062 L11.716,24.219 C12.095,24.5851875 12.095,25.1780625 11.716,25.5452187 L11.716,25.5452187 Z M16.122,1 L2,11.65625 L2,25.2700937 C2,28.9862187 5.122,32 8.973,32 L23.025,32 C26.877,32 30,28.9862187 30,25.2700937 L30,11.65625 L16.122,1 Z",
    id: 56
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingsNewConstruction);
export default __webpack_public_path__ + "static/media/buildings-new-construction.1d388d74.svg";
export { ForwardRef as ReactComponent };